

	import {
		Vue,
		Component
	} from 'vue-property-decorator'
	import 'umy-ui/lib/theme-chalk/index.css'
	import {ElForm} from "element-ui/types/form";
	import qs from 'qs';
	@Component({
		name: 'reportViewGzjs',
		components:{
		}
	})
	export default class reportViewGzjs extends Vue {

		loading=false
		beginMonth = ''
		ly = ''
		type = ''
		salaryData = ''
		allLy=[]
		created() {

		}
		mounted() {

			this.beginMonth = this.$route.query.month
			this.type = this.$route.query.type
			this.ly = this.$route.query.ly
			if (this.beginMonth && this.type&&this.ly) {
				this.getSalaryInData()
			}
			this.getAllLy(this.$route.query.month)
		}
		querySearch(queryString:string, cb:(arg0: any)=>{}) {

			// 调用 callback 返回建议列表的数据
			cb(this.allLy);
		}
		selectYl(value:string) {
			this.ly=value
			this.getSalaryInData()
		}
		getSalaryInData() {
			this.loading = true
			// var bmids = this.searchForm.bmid.map(value => "'"+value+"'").join(',');
			this.$request({
				method: 'get',
				url: '/bjba/salary/getGzjs',
				params: {type:this.type,month:this.beginMonth,ly:this.ly},
				paramsSerializer: params => {
					return qs.stringify(params, { indices: false })
				}
			}).then(res => {
				this.loading = false

				if (res.data.data && res.data.data.rs && res.data.data.rs > 0) {
					this.salaryData = res.data.data
				} else {
					this.$message.error("找不到工资数据")
					this.salaryData = ''
				}
				// this.dataList = res.data.data
			}).catch(error => {
				this.loading = false
			})
		}
		getAllLy(month: any) {
			this.$request({
				method: 'get',
				url: '/bjba/salary/getAllLy',
				params: {month: month}
			}).then(res => {
				this.allLy = res.data.data
				// this.dataList = res.data.data
			}).catch(error => {
				this.loading = false
			})
		}

		exportExcel() {
			// var viewUrl = `${this.$request.defaults.baseURL}/bjba/salary/getGzfsExcel?beginMonth=${this.beginMonth}&endMonth=${this.endMonth}&type=${this.type}&access_token=${this.$store.getters.token}`
			// window.open(viewUrl)
			if (this.ly) {
				this.$refs.exportForm.submit();
			} else this.$message.error("请输入来源")
		}
	}
